<script setup lang="ts">
interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

withDefaults(defineProps<Props>(), {
  size: 'sm',
});

// defineEmits<{
//   // (event: 'update:modelValue', payload: string): void
// }>()
</script>

<template>
  <q-card
    class="q-pa-md"
    :class="`wrapper-${size}`"
  >
    <slot></slot>
  </q-card>
</template>
